
import moment from 'moment';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { getExpense } from '@/api/coinManaging';
import { PageQuery } from '@/mixins/page_query';
import LogUtils from 'panda-log';
import { toast } from '../../../utils/common';
import { eConfigId, eBillingMethod, econsumptionType } from '../../../interface/eCommand';
import { iConsumeRecord, eOrderDuration } from '../../../interface/consume-record';
import DetailDialog from './consume-record-dialog.vue';
import { Areas } from '../../../utils/area';
@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    hour_miniute(mint: number) {
      let hour: number;
      let miniute: number;
      miniute = mint % 60;

      if (mint > 60) {
        hour = Math.floor(mint / 60);
        if (miniute === 0) {
          return `${hour}小时`;
        } else {
          return `${hour}小时${miniute}分`;
        }
      } else if (mint === 60) {
        return `${mint}分钟`;
      } else {
        return `${miniute}分钟`;
      }
    },
  },
  components: {
    DetailDialog,
  },
})
export default class RechargeRecord extends Mixins(PageQuery) {
  private start!: any;
  private end!: any;
  currentInfo: iConsumeRecord | null = null; //当前选择的订单内容
  detailDialogVisible: boolean = false; //详情弹窗是否显示
  areas: any[] = Areas;

  private loading = false;

  private experience: eConfigId = eConfigId.EXPERIENCE;
  private cloudcion = eBillingMethod.CLOUDCION;
  private experienceTwo = eBillingMethod.EXPERIENCE;
  private cyclecard = eBillingMethod.CYCLECARD;
  private cloudUpdate = eBillingMethod.CLOUDUPDATE;
  consumptionType = econsumptionType;
  private typeList = [
    { name: '请选择类别', id: 0 },
    { name: '游戏版', id: 1 },
    { name: '办公版', id: 2 },
  ];
  private dates: (string | Date)[] = [
    moment()
      .subtract('weeks', 2)
      .format('YYYY-MM-DD'),
    moment()
      .endOf('day')
      .format(),
  ];
  private pickerOptions = {
    shortcuts: [
      {
        text: '最近一周',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近一个月',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近三个月',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        },
      },
    ],
  };

  private configArr = ['全部状态', '标配服', '高配服', '体验服', '尊享服'];
  private configStatus: { name: string; id: number }[] = [
    { name: '全部状态', id: 0 },
    { name: '进行中', id: 1 },
    { name: '已结束', id: 2 },
  ];
  private tableData: iConsumeRecord[] = [];

  private query = {
    order_no: '',
    config_id: 0,
    store_name: '',
    store_id: '',
    nickname: '',
    uid: '',
    order_duration: 0,
    city_code: '',
    machine_id: '',
    ip: '',
  };
  orderDurationOptions: any[] = [
    { label: '不限制', value: eOrderDuration.DEFAULT },
    { label: '小于6分钟', value: eOrderDuration.LT_SIX_M },
    { label: '大于6分钟', value: eOrderDuration.GTE_SIX_M },
    { label: '进行中', value: eOrderDuration.CONDUCT },
  ];

  dateHandler(e: any) {
    this.start = moment(e[0], 'YYYY-MM-DD').unix();
    this.end = moment(e[1])
      .endOf('day')
      .unix();
  }
  searchList() {
    this.page_query.page = 1;
    this.getList();
  }
  statusChange() {}
  async getList() {
    try {
      this.loading = true;
      const query = {
        ...this.page_query,
        ...this.query,
        start: this.start,
        end: this.end,
      };
      const res = await getExpense(query);
      if (res && res.data.list) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  showDetail(info: iConsumeRecord) {
    LogUtils.debug('--info', info);
    this.detailDialogVisible = true;
    this.currentInfo = info;
  }
  handleChangeArea(value: any) {
    this.query.city_code = value[1];
    this.searchList();
  }
  mounted() {
    this.start = moment(this.dates[0]).unix();
    this.end = moment(this.dates[1]).unix();
    this.pageFn = this.getList;
    this.getList();
  }
}
